import { DataCard } from '../../../components/DashboardCard';
import { useAccountPackageCounts } from '../../../hooks/Dashboard/useAccountPackageCounts';
import { useOperator } from '../../../contexts/OperatorContext';

export const AccountCard = (props: DashboardCardProps) => {
  const { theme } = props;
  const { accountPackageCounts, getAccountPackageCounts, loading } =
    useAccountPackageCounts();
  const operator = useOperator();

  const mediaFirst = operator.systems
    ?.map((s) => s.name)
    ?.includes('Residential MediaFirst');
  const mediaRoom = operator.systems
    ?.map((s) => s.name)
    ?.includes('Residential MediaRoom');

  const mrColumns = [
    { name: 'Packages', dataKey: 'name' },
    { name: 'Enabled/Ttl', dataKey: 'mrCounts' },
  ];
  const mfColumns = [
    { name: 'Packages', dataKey: 'name' },
    { name: 'Enabled/Ttl', dataKey: 'mfCounts' },
  ];
  const mrMfColumns = [
    { name: 'Packages', dataKey: 'name' },
    { name: 'MR\nEnabled/Ttl', dataKey: 'mrCounts' },
    { name: 'MF\nEnabled/Ttl', dataKey: 'mfCounts' },
  ];

  const getColumns = () => {
    if (mediaFirst && !mediaRoom) return mfColumns;
    if (!mediaFirst && mediaRoom) return mrColumns;
    if (mediaFirst && mediaRoom) return mrMfColumns;
  };

  return (
    <DataCard
      data={accountPackageCounts}
      title="Accounts"
      views={['list', 'graph']}
      columns={getColumns()}
      leftLabel="Enabled Accounts (MR)"
      bottomLabel="Packages"
      loading={loading}
      refresh
      onRefresh={getAccountPackageCounts}
      theme={theme}
    />
  );
};
